import { motion } from "framer-motion";
import { useCatalog } from "../contexts/CatalogContext";

export function LoadingOverlay() {
  const { loading, progress, activePlaylist } = useCatalog();
  if (!loading) return null;

  const pct = progress && progress.total > 0
    ? Math.min(100, Math.floor((progress.loaded / progress.total) * 100))
    : null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-canvas/80 backdrop-blur-sm flex items-center justify-center"
    >
      <div className="w-[min(420px,90vw)] glass-panel rounded-xl p-8 text-center">
        <div className="font-display text-[40px] tracking-[-1px] mb-3">
          <span className="text-text-primary">8K </span>
          <span className="text-accent-gold">BRAINZR</span>
        </div>
        <p className="text-[14px] font-ui text-text-secondary mb-6">
          Loading catalog{activePlaylist ? ` · ${activePlaylist.name}` : ""}…
        </p>
        <div className="h-2 rounded-pill bg-surface overflow-hidden mb-3">
          {pct !== null ? (
            <motion.div
              className="h-full bg-accent-gold"
              initial={{ width: 0 }}
              animate={{ width: `${pct}%` }}
              transition={{ duration: 0.2 }}
            />
          ) : (
            <div className="h-full skeleton-shimmer" />
          )}
        </div>
        <p className="text-[12px] font-mono text-text-muted">
          {pct !== null
            ? `${pct}% · ${formatBytes(progress!.loaded)} of ${formatBytes(progress!.total)}`
            : progress
              ? `${formatBytes(progress.loaded)} received…`
              : "Connecting…"}
        </p>
      </div>
    </motion.div>
  );
}

function formatBytes(n: number): string {
  if (!n) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}
